<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
    <el-form ref="info" class="global-form2" :model="info" :rules="rules" label-position="right" label-width="110px">
      <el-form-item prop="templateName" label="模板名称">
        <el-input v-model="info.templateName" placeholder="请输入模板名称" maxlength="30" />
      </el-form-item>
      <el-form-item label="使用项目" prop="projectIds">
        <el-select v-model="info.projectIds" multiple filterable placeholder="请选择使用项目">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="日报项">
        <el-table class="global-table global-tables my-table" @select="select" @select-all="selectAll"
          @selection-change="selectionLineChangeHandle" max-height="400" :data="dailyOptionList" border ref="table">
          <el-table-column show-overflow-tooltip type="selection"></el-table-column>
          <el-table-column label="日报项名称" show-overflow-tooltip prop="dicValue"></el-table-column>
          <el-table-column label="分享" min-width="60px" show-overflow-tooltip>
            <template v-slot="{ row }">
              <el-switch :disabled="!row.flag" :active-value="1" :inactive-value="0" v-model="row.isShare"
                active-color="#7973ef" inactive-color="#333333">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveForm" :disabled='submitShow'>保存</el-button>
        <el-button @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>

export default {
  name: 'DailyTemplateListAdd',
  props: {
    addShow: {
      type: Boolean,
      default: false
    },
    id: String
  },
  data () {
    return {
      dialogVisible: false,
      info: {
        templateId: '',
        isDisable: '',
        templateName: '',
        projectIds: [],
        optionList: []
      },

      title: '新增日报模板',

      BindingProjectList: [], // 绑定项目模板
      submitShow: false,
      dailyOptionList: [], // 日报配置
      rules: {
        templateName: [
          { required: true, message: '请输入模板名称', trigger: 'change' }
        ],
        projectIds: [
          { required: true, message: '请选择使用项目', trigger: 'change' }
        ]
        // ,
        // optionList: [
        //   { required: false, message: '请选择日报项', trigger: 'change' }
        // ]
      }
    }
  },
  computed: {
    projectList () {
      let projectList = []
      projectList = this.$store.state.projectList.filter((item) => {
        return this.BindingProjectList.every((k) => k !== item.projectId)
      })
      // console.log('projectList', projectList)
      // this.BindingProjectList
      // if (this.id && this.id !== 'add') {
      //   console.log('添加自身id')
      //   projectList = [...projectList, ...this.projectIds]
      // }
      return projectList
    }
  },
  watch: {
    addShow (val) {
      this.dialogVisible = val
    },
    id (val) {
      this.$nextTick(() => {
        this.$refs.table.clearSelection()
      })
      if (val === 'add') {
        // console.log('新增')
        this.title = '新增日报模板'
        this.getBindingProjectTemptate() // 获取已经绑定的项目模板（绑定过的不能选）
        this.getDailyReportList()// 获取日报项列表
      } else if (val) {
        // console.log('编辑')
        this.title = '编辑日报模板'
        const res1 = this.$axios.get(this.$apis.maintenanceDaily.selectYhProjectDailyTemplateList) // 获取已经绑定的项目模板（绑定过的不能选）
        const res2 = this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'dailyOptionType' }) // 获取日报项列表
        const res3 = this.$axios.get(this.$apis.maintenanceDaily.selectYhDailyTemplateByTemplateId, { templateId: this.id }) // 模板详情
        Promise.all([res1, res2, res3]).then((res) => {
          // console.log('Promiseres', res)
          // 回显日报模板名称
          this.info.templateName = res[2].templateName
          this.info.templateId = res[2].templateId
          this.info.isDisable = res[2].isDisable

          // 处理项目
          this.BindingProjectList = res[0].filter((item) => {
            return item.templateId
          }).map((k) => {
            return k.projectId
          })

          const arr = []
          res[2].projectList.forEach((item) => {
            arr.push({
              projectId: item.projectId,
              projectName: item.projectName
            })
          })
          this.projectList.push(...arr)
          this.info.projectIds = res[2].projectList.map((item) => item.projectId)

          // 处理日报项
          res[1].dailyOptionType.forEach((item) => {
            item.isShare = 0 // 默认为不分享状态
            item.flag = false // 默认禁用分享状态
          })
          this.dailyOptionList = res[1].dailyOptionType
          this.dailyOptionList.forEach((item) => {
            let isDisplay = false
            isDisplay = res[2].optionList.some((k) => {
              return item.dicCode === k.dailyOptionType
            })
            if (isDisplay) {
              this.$nextTick(() => {
                this.$refs.table.toggleRowSelection(item, true)
                const target = res[2].optionList.find((t) => {
                  return item.dicCode === t.dailyOptionType
                })
                // 回显禁用和分享状态
                if (item.dicCode !== '1') {
                  item.isShare = target.isShare
                  item.flag = true
                }
                // console.log('target', target)
              })
            }
          })
        })
      }
    }
  },

  // @Watch('detailShow', { immediate: true })
  // isDetail (val: string) {
  //   val && this.getDetail()
  // }

  created () {
    // this.getBindingProjectTemptate() // 获取已经绑定的项目模板
  },
  methods: {
    getBindingProjectTemptate () {
      this.$axios.get(this.$apis.maintenanceDaily.selectYhProjectDailyTemplateList).then(res => {
        this.BindingProjectList = res.filter((item) => {
          return item.templateId
        }).map((k) => {
          return k.projectId
        })
        // this.BindingProjectList = ['20211220093111461403']
        // console.log('this.BindingProjectList', this.BindingProjectList)
      })
    },

    getDailyReportList () {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'dailyOptionType' }).then(res => {
        // console.log('res3', res)
        res.dailyOptionType.forEach((item) => {
          item.isShare = 0
          item.flag = false
        })
        this.dailyOptionList = res.dailyOptionType
      })
    },

    getDetail () {
      this.$axios.get(this.$apis.maintenanceDaily.selectYhDailyTemplateByTemplateId, { templateId: this.id }).then(res => {
        if (res) {
          this.info = res
        }
      })
    },

    // 选择日报项-处理禁用和关联分享的选中状态
    select (val, row) {
      // console.log('select', val, row)
      // this.$nextTick(() => {
      if (row.dicCode !== '1') {
        if (row.flag) {
          row.isShare = 0
        } else {
          row.isShare = 1
        }
        row.flag = !row.flag
      }
    },

    selectAll (val) {
      // console.log('selectAll', val)
      if (val.length) {
        this.dailyOptionList.forEach((item) => {
          this.$nextTick(() => {
            if (item.dicCode !== '1') {
              item.isShare = 1
              item.flag = true
            }
          })
        })
      } else {
        this.dailyOptionList.forEach((item) => {
          this.$nextTick(() => {
            if (item.dicCode !== '1') {
              item.isShare = 0
              item.flag = false
            }
          })
        })
      }
    },

    // 选择日报项-处理提交的值
    selectionLineChangeHandle (val) {
      // console.log('selectionLineChangeHandle', val)
      this.info.optionList = val
    },

    saveForm () {
      // console.log('this.info', this.info);
      // console.log('this.dailyOptionList', this.dailyOptionList);
      this.$refs.info.validate(valid => {
        if (valid) {
          if (!this.info.optionList.length) {
            this.$message.warning('至少添加一项日报项！')
            return
          }
          const params = JSON.parse(JSON.stringify(this.info))
          params.optionList = params.optionList.map((item) => {
            return {
              dailyOptionType: item.dicCode,
              isShare: parseInt(item.isShare)
            }
          })
          this.submitShow = true
          const urls = this.id === 'add' ? this.$apis.maintenanceDaily.insertYhDailyTemplate : this.$apis.maintenanceDaily.updateYhDailyTemplate
          this.$axios.post(urls, params).then(() => {
            this.$message.success('保存成功')
            this.handleClose()
            this.$emit('success')
          }).finally(() => {
            this.submitShow = false
          })
        }
      })
    },

    handleClose () {
      // console.log('关闭弹窗')
      this.$emit('update:addShow', false)
      this.$emit('update:id', '')
      this.info = {
        templateId: '',
        isDisable: '',
        templateName: '',
        projectIds: [],
        optionList: []
      }
      this.BindingProjectList = []
      this.dailyOptionList = [];
      (this.$refs.info).resetFields()
    }
  }

}
</script>

<style scoped lang="scss">
.global-form2 .el-textarea {
  width: 380px;
}

::v-deep .el-table {
  width: 380px;
}

::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}
</style>
